import React from 'react';
import { Link } from 'react-router-dom';


export const Landing = () => {
    return (
        <div className="container-fluid header">
 	<div className="container">
 		<div className="row">

 			<div className="col-sm-12 col-md-6 align-self-center">
				 
 				<div className="header-text">
 					<h1>We are Digital Transformers</h1>
 					<br />
 					<h5>We are a design agency that makes beautiful things. We pride ourselves in creating beautiful
 						solutions and meeting challenges.
 					</h5>
 					<hr />
 					<Link role="button" to="/MobileApp" className="btn btn-primary">read more</Link>
 				</div>
 			</div>
 			<div className="col-sm-12 col-md-6">
 				<img src='./img/object-1.png' className="img-fluid header-image" />

 			</div>
 		</div>

 	</div>
 </div>
    )
}

export default Landing;
